import axios from "axios";


const periods = ({
    accountID,
    showID,
    report,
    period,
    startDate,
    endDate,
    attributionWindow,
    filters,
    id,
}) =>
    axios
        .post(`/api/${ accountID }/links/${ showID}/reports/${ report }/periods`, {
            accountID,
            period,
            startDate,
            endDate,
            attributionWindow,
            filters,
            id,
        })
        .then(({ data }) => data);

const placements = ({ accountID, showID }) =>
    axios
        .get(`/api/${ accountID }/links/${ showID }`)
        .then((res) => res.data);

const report = ({
    accountID,
    showID,
    report,
    period,
    startDate,
    endDate,
    attributionWindow,
    filters,
}) =>
    axios
        .post(`/api/${ accountID }/links/${ showID }/reports/${ report }`, {
            accountID,
            showID,
            period,
            startDate,
            endDate,
            attributionWindow,
            filters,
        })
        .then(({ data }) => data);

export const api = {
    periods,
    placements,
    report,
};
